import React, { Component } from 'react';
import { URLImgFront } from '../../config/URLDB';

class Seccion1 extends Component {
    constructor(props) {
        super(props);
        this.state = {

        };
    }
    render() {
        return (
            <React.Fragment>
                <div className="descargar_formatos_diseño" style={{ width: '100%', paddingTop: '120px' }}>
                    <img style={{ width: '100%', height: '40vh', objectFit: 'cover' }} className="img-fluid" src={`${URLImgFront}/assets/img_principal/PORTADA FORMATOS.png`} alt="img1" />
                    <div className="contenido_texto_f text-center" style={{ position: 'absolute', top: '280px', left: '0', right: '0', zIndex: '2' }}>
                        <p style={{ fontSize: '20px', color: '#fff' }}>Aquí puede</p>
                        <p style={{ fontSize: '40px', color: '#fff', fontWeight: 'bold' }}>DESCARGAR FORMATOS</p>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

export default Seccion1;